module.exports = __webpack_public_path__ + "static/media/male_tshirt.065fab81.png";